'use strict';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { IconButton } from '@mui/material';

import {
    Fullscreen,
    KeyboardArrowDown,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    KeyboardArrowUp
} from '@mui/icons-material';

export const ImageGallery = props => {
    const images = props.itemDetails.images || [{ mediaUrl: '/assets/images/img-placeholder.png' }];

    useEffect(() => {
        if (window.lightbox) {
            window.lightbox.option({
                alwaysShowNavOnTouchDevices: true,
                wrapAround: true
            });
        }

        $('.slick-thumbnails').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: false,
            draggable: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 833,
                    settings: {
                        vertical: true,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });

        if (images) {
            images.map((m, i) => {
                $('.slick-thumbnails').slick(
                    'slickAdd',
                    `
                        <li style="width: '100%'; display: 'inline-block'">
                            <a data-lightbox="group" data-imgurl="${m.mediaUrl}" href=${m.mediaUrl} tabIndex="${i}" style="width: 100%; height: 100%">
                                <img src=${m.mediaUrl} alt="thumbnail" className="img-responsive" style="object-fit: cover; width: 100%; height: 100%;" />
                            </a>
                        </li>
                    `
                );
            });
        }

        if (images.length > 1) {
            setTimeout(() => {
                $('.lb-nav a.lb-next, .lb-nav a.lb-prev').css({
                    display: 'block',
                    opacity: '1'
                });
            }, 500);
        }

        // Hide default slick navs
        $('.slick-next, .slick-prev').hide();
    }, [images]);

    const handlePreviewClick = () => {
        $('.slick-thumbnails li[data-slick-index="0"] a').trigger('click');
    };

    const handleThumbnailPrevClick = () => {
        $('.slick-prev').trigger('click');
    };

    const handleThumbnailNextClick = () => {
        $('.slick-next').trigger('click');
    };

    return (
        <div className='gallery-container tw-w-full tw-mx-auto'>
            <div className='thumbnail-sidebar tw-gap-[4px]'>
                {images.length > 1 && (
                    <button
                        onClick={handleThumbnailPrevClick}
                        className='tw-flex tw-justify-center tw-items-center tw-text-[16px]'
                    >
                        <KeyboardArrowUp weight='bold' className='arrow-up' />
                        <KeyboardArrowLeft weight='bold' className='arrow-left' />
                    </button>
                )}
                <ul className='slick-thumbnails' />
                {images.length > 1 && (
                    <button
                        onClick={handleThumbnailNextClick}
                        className='tw-flex tw-justify-center tw-items-center tw-text-[16px]'
                    >
                        <KeyboardArrowDown weight='bold' className='arrow-down' />
                        <KeyboardArrowRight weight='bold' className='arrow-right' />
                    </button>
                )}
            </div>
            <div className={cn(['preview-container tw-relative', 'tw-h-full tw-w-full'])}>
                <button onClick={handlePreviewClick} className='tw-w-full tw-h-full'>
                    <img
                        src={images[0].mediaUrl}
                        alt='thumbnail'
                        className={cn(['preview-image', 'tw-h-full tw-w-full tw-max-h-[190px] md:tw-max-h-[450px]'])}
                    />
                </button>
                <ul className='slick-preview' />
                <div>
                    <IconButton
                        aria-label='Favorite service'
                        className='sc-favorite tw-rounded-md sm:tw-flex tw-w-[32px] tw-h-[32px] tw-flex-shrink-0 tw-bg-primary-500 hover:tw-bg-primary-500 tw-absolute tw-top-1 tw-left-1 tw-d-none'
                        onClick={handlePreviewClick}
                    >
                        <Fullscreen weight='fill' className='tw-text-white' />
                    </IconButton>
                </div>
            </div>
        </div>
    );
};

ImageGallery.propTypes = {
    itemDetails: PropTypes.shape({
        images: PropTypes.arrayOf(
            PropTypes.shape({
                mediaUrl: PropTypes.string.isRequired
            })
        )
    }).isRequired,
    user: PropTypes.shape({
        Guest: PropTypes.bool
    }).isRequired
};
